<div class="w-full lead-timeline">
    <div class="text-[18px] font-semibold mt-1 mb-7">
        {{title}}
    </div>
    <p-timeline [value]="events">
        <ng-template #marker let-event>
            <span class="flex w-8 h-8 items-center justify-center rounded-full z-10 shadow-sm timeline-marker">
                {{ getInitials(event.name) }}
            </span>
        </ng-template>
        <ng-template #content let-event>
            <div
                class="timeline-content-card  rounded-lg shadow-sm border p-3 md:p-4 hover:shadow-md transition-shadow duration-200">
                <!-- Header Section -->
                <div class="flex justify-between items-start mb-3">
                    <div class="flex-1">
                        <h3 class="text-[12px] md:text-[15px] font-semibold text-gray-800 dark:text-white  mb-1">{{ event.name }}</h3>
                        <div class="text-[9px]  md:text-[11px] text-gray-500 dark:text-gray-100 font-medium">{{ event.date }}</div>
                    </div>
                    <div class="flex gap-2 ml-4" *ngIf="isUpdate || isDelete">
                        <!-- Edit Button -->
                        <div class="group p-1.5
                        h-[30px] w-[30px]
                        flex items-center justify-center cursor-pointer
                        rounded-full transition-colors duration-150 hover:bg-blue-600"
                            *ngIf="isUpdate" (click)="handleEditTimeline(event)" title="Edit">
                            <i class="pi pi-pen-to-square text-blue-600 group-hover:text-white"
                                style="font-size: 1rem"></i>
                        </div>

                        <!-- Delete Button -->
                        <div class="group p-1.5
                         h-[30px] w-[30px]
                        flex items-center justify-center cursor-pointer
                        rounded-full transition-colors duration-150 hover:bg-red-600"
                            *ngIf="isDelete" (click)="handleDeleteTimeline(event)" title="Delete">
                            <i class="pi pi-trash text-red-600 group-hover:text-white" style="font-size: 1rem"></i>
                        </div>
                    </div>

                </div>

                <!-- Content Section -->
                <div class="timeline-description">
                    <!-- Enhanced Description Parsing with highlighting -->
                    <div class="text-[13px] leading-relaxed description-content"
                        [innerHTML]="formatDescription(event.desc)">
                    </div>

                    <!-- Document Preview -->
                    <div class="mt-3" *ngIf="event.document_type == 'document_preview'">
                        <a href="{{event.document_url}}" target="_blank"
                            class="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 text-[13px] font-medium underline decoration-blue-300 hover:decoration-blue-500 transition-colors duration-150">
                            <i class="pi pi-external-link" style="font-size: 0.7rem"></i>
                            View Document
                        </a>
                    </div>

                    <!-- Status Badge (if applicable) -->
                    <!-- <div class="mt-3" *ngIf="getStatusFromDescription(event.desc)">
                        <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium status-badge"
                              [ngClass]="getStatusBadgeClass(getStatusFromDescription(event.desc))">
                            {{ getStatusFromDescription(event.desc) }}
                        </span>
                    </div> -->
                </div>
            </div>
        </ng-template>

    </p-timeline>

    <!-- No Data State -->
    <div class="flex flex-col items-center justify-center py-12 text-center" *ngIf="events.length == 0">
        <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <i class="pi pi-clock text-gray-400 text-2xl"></i>
        </div>
        <div class="text-[15px] font-semibold text-gray-600 mb-2">No Timeline Events</div>
        <div class="text-[13px] text-gray-500">Events and updates will appear here</div>
    </div>
</div>


<p-dialog [modal]="true" [visible]="opnModelDialogValue == 'editNote'"
    [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">
    <app-add-note 
    [lead_id]="selectedEvent?.lead_id"
    (closeDialog)="handleCloseDIalog()" [editLeadData]="selectedEvent" [events]="events" [isUpdate]="true"
        [title]="'Edit Note'"></app-add-note>
</p-dialog>

<p-dialog [modal]="true" [visible]="opnModelDialogValue == 'editTask'"
    [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">
    <app-lead-task (closeDialog)="handleCloseDIalog()" [editLeadData]="selectedEvent" [events]="events"
        [isUpdate]="true" [title]="'Edit Task'">
    </app-lead-task>
</p-dialog>


<p-dialog [modal]="true" [visible]="openDeleteDialog" [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <app-delete-timeline-action (closeDialog)="handleCloseDIalog()" [title]="deleteTitle"
        [deleteLoading]="deleteLoading" [description]="deleteDescription"
        (deleteTimeLine)="handleDeleteTimelineEvent()"></app-delete-timeline-action>
</p-dialog>